module.exports = __webpack_public_path__ + "img/downloadFirst.cafabf2d.png";